const domain = "https://ar.aonegames.com";
// const domain = "http://192.168.0.16:3005";

export { domain };
